"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkerCache = exports.NetworkerCache = void 0;
var networker_cache_utils_1 = require("./networker-cache-utils");
var NetworkerCache = /** @class */ (function () {
    function NetworkerCache(config) {
        if (config === void 0) { config = {}; }
        this.networkerCacheData = this.getObjectFromStorage();
        this.allowedMethod = config.allowedMethod || ['GET', 'POST', 'PUT', 'DELETE'];
    }
    NetworkerCache.prototype.get = function (url, params) {
        var index = networker_cache_utils_1.networkerCacheUtils.getMatchIndex(url, params, this.networkerCacheData);
        if (index !== -1) {
            return this.networkerCacheData[index];
        }
        return null;
    };
    NetworkerCache.prototype.set = function (requestData) {
        var index = networker_cache_utils_1.networkerCacheUtils.getMatchIndex(requestData.url, requestData.requestOptions, this.networkerCacheData);
        if (index === -1) {
            this.networkerCacheData.push(requestData);
        }
    };
    NetworkerCache.prototype.delete = function (requestData) {
        var index = networker_cache_utils_1.networkerCacheUtils.getMatchIndex(requestData.url, requestData.requestOptions, this.networkerCacheData);
        this.networkerCacheData.splice(index, 1);
    };
    NetworkerCache.prototype.getObjectFromStorage = function () {
        // get from storage if needed
        return [];
    };
    return NetworkerCache;
}());
exports.NetworkerCache = NetworkerCache;
exports.networkerCache = new NetworkerCache();
//# sourceMappingURL=networker-cache.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/networker/lib/networker-cache.js
// module id = 1196
// module chunks = 8